import type { ExpressionSpecification } from 'mapbox-gl'

const bulkyWasteOrderTypeColors = {
  SB: '#818cf8',
  SP: '#818cf8',
  WA: '#facc15',
  '24': '#34d399',
  SV: '#818cf8',
  WV: '#facc15',
  '2V': '#34d399',
  SN: '#818cf8',
  WN: '#facc15',
  TS: '#38bdf8',
  TV: '#38bdf8',
  TN: '#38bdf8',
} satisfies Record<App.Enums.BulkyWasteOrderType, string>

export const bulkyWasteOrderTypes = [
  'SB',
  'SP',
  'WA',
  '24',
  'SV',
  'WV',
  '2V',
  'SN',
  'WN',
  'TS',
  'TV',
  'TN',
] as const satisfies readonly App.Enums.BulkyWasteOrderType[]

function matchExpression(
  values: Record<App.Enums.BulkyWasteOrderType, string>,
  fallback: string,
): ExpressionSpecification {
  return [
    'match',
    ['get', 'type'],
    ...Object.entries(values).flatMap(([value, result]) => [value, result]),
    fallback,
  ] as ExpressionSpecification
}

export const bulkyWasteOrderTypeColorExpression = matchExpression(
  bulkyWasteOrderTypeColors,
  '#000000',
)

export function bulkyWasteOrderTypeLabelExpression(
  labels: Record<App.Enums.BulkyWasteOrderType, string>,
): ExpressionSpecification {
  return matchExpression(labels, 'Unbekannte Auftragsart')
}
